import { html } from "lit";

interface TemplateArgs {
    count?: number;
}

const renderSlide = (index: number) => html`
    <ux-slider-slide>
        <div class="embed-video">
            <div class="ux-u-margin-bottom-15">
                <ux-video>
                    <video controls="" preload="none">
                        <source
                            src="https://media.trumpf.com/m/333790ceedfb1be9/original/Schweikantenformer-Video-uber-den-Einsatzbereich.mp4"
                            type="video/mp4"
                        />
                    </video>
                </ux-video>
            </div>
            <div
                class="ux-u-margin-bottom-15 ux-text-normal ux-u-text-align--left caption"
            >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit slide
                ${index + 1}.
            </div>
        </div>
    </ux-slider-slide>
`;

export const Template = ({ count }: TemplateArgs) => html`
    <div class="ux-t-container-full ux-theme-nimbus ux-u-mb-fluid-s">
        <div class="ux-row ux-u-mx-zero ux-u-flex-jc-center">
            <div class="ux-col-12 ux-col-sm-10 ux-col-lg-8 ux-u-px-sm-zero">
                <ux-slider loop="">
                    ${new Array(count || 1)
                        .fill(0)
                        .map((_, index) => renderSlide(index))}
                    ${count > 1
                        ? html`
                              <ux-slider-pagination
                                  slot="pagination"
                                  bottom-pagination=""
                              ></ux-slider-pagination>
                          `
                        : ""}
                </ux-slider>
            </div>
        </div>
    </div>
`;
